import { useTranslation } from 'react-i18next';

const API_URL = import.meta.env.VITE_API_URL as string;

interface Props {
  invitationToken?: string | null;
  onClick?: () => void;
}

/**
 * ADR-0026: Apple's guidelines ask for its own black button, as prominent as
 * any other sign-in option — so it sits next to Google at the same size.
 */
export function AppleSignInButton({ invitationToken, onClick }: Props) {
  const { t } = useTranslation();
  // Off until the Apple Developer account, Services ID and .p8 exist: without
  // them the server answers 501 and the button would lead to a raw error page.
  if (import.meta.env.VITE_APPLE_SIGNIN_ENABLED !== 'true') return null;
  const href = `${API_URL}/auth/apple${invitationToken ? `?invitationToken=${encodeURIComponent(invitationToken)}` : ''}`;

  return (
    <a
      href={href}
      onClick={onClick}
      className="flex items-center justify-center gap-2.5 text-sm font-medium transition-all no-underline"
      style={{ height: 48, background: '#000', border: '1px solid #000', borderRadius: 10, color: '#fff', cursor: 'pointer' }}
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M16.37 1.43c0 1.14-.42 2.2-1.25 3.17-1 1.17-2.21 1.84-3.52 1.74a3.5 3.5 0 0 1-.03-.43c0-1.1.48-2.27 1.33-3.23.42-.49.96-.89 1.6-1.21.65-.31 1.26-.48 1.83-.51.02.16.04.31.04.47zm4.6 16.06c-.36.84-.79 1.6-1.29 2.3-.68.96-1.24 1.63-1.67 2-.67.62-1.39.93-2.16.95-.55 0-1.22-.16-2-.48-.78-.32-1.5-.48-2.15-.48-.69 0-1.42.16-2.21.48-.79.32-1.42.49-1.91.51-.74.03-1.48-.29-2.21-.98-.47-.41-1.06-1.11-1.76-2.1-.75-1.06-1.37-2.28-1.86-3.68C1.23 14.5.97 13.04.97 11.62c0-1.62.35-3.03 1.05-4.2a6.17 6.17 0 0 1 2.2-2.23 5.9 5.9 0 0 1 2.97-.84c.58 0 1.34.18 2.29.53.94.36 1.55.54 1.81.54.2 0 .88-.21 2.04-.63 1.09-.39 2.02-.56 2.77-.49 2.05.17 3.6.98 4.62 2.44-1.84 1.11-2.75 2.67-2.73 4.67.02 1.56.58 2.86 1.69 3.89.5.48 1.06.85 1.68 1.11-.13.39-.28.77-.43 1.13z" />
      </svg>
      {t('auth.login.continueWithApple')}
    </a>
  );
}
